export default __webpack_public_path__ + "static/media/icon_carousel_next.3a712d00.svg";